// extracted by mini-css-extract-plugin
export var icon = "_4f-3";
export var subtitle = "_4f-2";
export var title = "_4f-1";
export var value = "_4f-0";